import { BrowserClient, browserTracingIntegration, defaultStackParser, getClient, init, makeFetchTransport, replayIntegration, captureException as sentryCaptureException, setCurrentClient, withIsolationScope } from '@sentry/react';
import { isLocalhost, isProductionOnlyEnv, isWindowExist } from '@fttb/common/utils';
import { sentryKnownErrorsList } from "./constants";
var sentryClient = null;
var captureExceptionMethod = sentryCaptureException;
export var isSentryAllowed = function isSentryAllowed() {
  return isProductionOnlyEnv() && isWindowExist() && !isLocalhost();
};
export var initializeSentryScope = function initializeSentryScope() {
  var _window;
  if (!isSentryAllowed() || sentryClient) return;

  // FIXME: BCW-9760
  // const env = getCurrentEnvCookie() || 'production';
  //
  // // Временно пока так. Ивенты сыпятся со всех стендов, большая нагрузка на инфру
  // if (env !== 'production') return;
  // @ts-expect-error window custom type
  if (!((_window = window) !== null && _window !== void 0 && _window.fttbSentryEnabled)) return;
  var sentryOptions = {
    dsn: 'https://dfa99fac0c1ff6f4fe73fa2403ab478b@sentry-relay.beeline.ru/183',
    debug: isLocalhost(),
    ignoreErrors: sentryKnownErrorsList,
    integrations: [browserTracingIntegration(), replayIntegration()],
    environment: 'production',
    tracesSampleRate: 0.15,
    sampleRate: 0.6,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.5,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    denyUrls: ['flocktory.com', 'mc.yandex.ru', 'diginetica.net', 'bee-cake.ru', 'gdeslon.ru', 'vk.com', 'chrome://', 'mail.ru', 'vimpelcom.ru', 'widgetpay1.beeline.ru']
  };
  if (getClient()) {
    withIsolationScope(function (scope) {
      sentryClient = new BrowserClient(sentryOptions);
      setCurrentClient(sentryClient);
      sentryClient.init();
      captureExceptionMethod = sentryClient.captureException.bind(sentryClient);
      scope.setTag('version', process.env.VERSION);
      scope.setTag('location', window.location.href);
    });
    return;
  }
  init(sentryOptions);
};
export var captureException = captureExceptionMethod;